<template>

  <upload-excel-component :sheet-names="'.*'"
                          :on-success="onSuccessExcelFileUpload"
                          :before-upload="beforeExcelFileUpload"
                          :multiple="false"
                          :title="title"
                          :json-options="xlsJsonOptions"
                          :json-sheet-options="xlsJsonSheetOptions"
  />
</template>

<script>
// npm
// components
import UploadExcelComponent from '@/components/UploadExcel/index'
// other
import {parseXlsTable, convertExcelSerialDate, convertToString} from '@/utils/excel'

export default {
  name: 'FlightOrdersUpload',
  components: {UploadExcelComponent},
  props: {
    title: String
  },
  data () {
    return {
      xlsJsonOptions: {
        header: ['num', 'depDate', 'from', 'to', 'lastName', 'firstName', 'middleName', 'docNum', 'mvz', 'organization', 'birthDate', 'contacts', 'email', 'timeFrom', 'initiator', 'initiatorEmail', 'initiatorPhone', 'createOrderDate'],
        converters: {
          depDate: convertExcelSerialDate,
          birthDate: convertExcelSerialDate,
          createOrderDate: convertExcelSerialDate,
          mvz: convertToString,
          initiatorPhone: convertToString,
          docNum: convertToString
        },
        blankrows: true,
        parseComments: true
      },

      xlsJsonSheetOptions: {
        0: {
          header: ['num', 'depDate', 'from', 'to', 'lastName', 'firstName', 'middleName', 'docNum', 'mvz', 'organization', 'birthDate', 'contacts', 'email', 'timeFrom', 'initiator', 'initiatorEmail', 'initiatorPhone', 'createOrderDate'],
          converters: {
            depDate: convertExcelSerialDate,
            birthDate: convertExcelSerialDate,
            createOrderDate: convertExcelSerialDate,
            mvz: convertToString,
            initiatorPhone: convertToString,
            docNum: convertToString
          },
          blankrows: true
        },
        1: {
          header: ['transportType', 'depDate', 'from', 'to', 'placeCount', 'name', 'dimensions', 'weight', 'mvz', 'organization', 'packType', /*'contacts', 'email',*/ 'timeFrom', 'initiator', 'initiatorEmail', 'initiatorPhone', 'createOrderDate'],
          converters: {
            depDate: convertExcelSerialDate,
            createOrderDate: convertExcelSerialDate,
            mvz: convertToString,
            initiatorPhone: convertToString,
            docNum: convertToString
          },
          blankrows: true
        }
      }

    }
  },
  methods: {
    beforeExcelFileUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 10

      if (isLt1M) {
        return true
      }

      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    /**
     * Note: for multiple upload arguments will be different
     */
    onSuccessExcelFileUpload ({file, results, props, custprops}) {
      const sheetNames = Object.keys(results)

      let allXlsItems = []
      for (let idx in sheetNames) {
        const sheetName = sheetNames[idx]
        const sheetResults = results[sheetName]

        const tableData = sheetResults.results
        const tableHeader = sheetResults.header

        const defaultJsonOptions = { header: this.xlsJsonOptions.header }
        let options = Object.assign(defaultJsonOptions, this.jsonOptions)
        if (this.xlsJsonSheetOptions && this.xlsJsonSheetOptions[sheetName]) {
          options = Object.assign(options, this.xlsJsonSheetOptions[sheetName])
        } else if (this.xlsJsonSheetOptions && this.xlsJsonSheetOptions[idx]) {
          options = Object.assign(options, this.xlsJsonSheetOptions[idx])
        }
        let objectKeys = options.header

        const FIRST_ROW = 5 - 1
        const xlsItems = parseXlsTable({
          results: tableData,
          props,
          custprops,
          header: tableHeader
        }, FIRST_ROW, objectKeys, this.xlsJsonOptions.converters)

        // second tabs will have marker isCargo
        if (idx > 0) {
          xlsItems.forEach(item => {
            item.isCargo = true
          })
        }

        allXlsItems = allXlsItems.concat(xlsItems)
      }

      this.$emit('success-upload', {source: file, xlsItems: allXlsItems})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
</style>



// WEBPACK FOOTER //
// src/components/flight-orders/FlightOrdersUpload.vue